(function () {
  'use strict';

  function selectedVariant(modal) {
    var node = modal.querySelector('[data-selected-variant]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || 'null'); }
    catch (error) { return null; }
  }

  function syncForm(modal, variantOverride) {
    var variant = variantOverride || selectedVariant(modal);
    var input = modal.querySelector('input.product-variant-id');
    var button = modal.querySelector('.product-form__submit');
    var label = button && button.querySelector('span');
    if (!input || !button) return;

    var nextValue = variant && variant.id ? String(variant.id) : '';
    var nextDisabled = !variant || !variant.available;
    var nextLabel = !variant
      ? window.variantStrings.unavailable
      : (variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut);

    if (input.value !== nextValue) input.value = nextValue;
    if (input.disabled !== nextDisabled) input.disabled = nextDisabled;
    if (button.disabled !== nextDisabled) button.disabled = nextDisabled;

    var nextAriaDisabled = nextDisabled ? 'true' : 'false';
    if (button.getAttribute('aria-disabled') !== nextAriaDisabled) {
      button.setAttribute('aria-disabled', nextAriaDisabled);
    }

    // Replacing textContent creates a child-list mutation. Only write when the
    // text actually changed so the observer cannot trigger itself forever.
    if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
  }

  function syncAfterCurrentTask(modal, variantOverride) {
    window.setTimeout(function () {
      if (document.documentElement.contains(modal)) syncForm(modal, variantOverride);
    }, 0);
  }

  function enhance(modal) {
    if (!modal || modal.dataset.jmtFitModalReady === 'true') return;
    modal.dataset.jmtFitModalReady = 'true';
    syncForm(modal);
    syncAfterCurrentTask(modal);
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'open');
      })) {
        syncForm(modal);
        syncAfterCurrentTask(modal);
      }
    }).observe(modal, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    modal.addEventListener('change', function () {
      syncAfterCurrentTask(modal);
    });
    modal.addEventListener('submit', function () { syncForm(modal); }, true);
  }

  function ready(root) {
    (root || document).querySelectorAll('.jmt-pdp-fit-modal').forEach(enhance);
  }

  function subscribeToVariantChanges() {
    if (window.JMTPdpFitModalSubscriptionReady) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    window.JMTPdpFitModalSubscriptionReady = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;

      var modal = document.getElementById('JmtPdpFitModal-' + data.sectionId);
      if (modal) {
        syncForm(modal, data.variant || null);
        syncAfterCurrentTask(modal, data.variant || null);
      }
    });
  }

  function initialize(root) {
    ready(root);
    subscribeToVariantChanges();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
